import { useEffect, useState } from 'react';

/**
 * Keeps contentEditable / textarea height in sync with text (Build + Agentic).
 * Cap matches ``max-h-[200px]`` in ``getWorkbenchPromptInputClassName``.
 *
 * Returns the measured content height (px) so callers can flip the composer
 * from the single-row pill to the taller two-deck card once the prompt grows
 * past a line or two (a one-liner pill can't hold a multi-line prompt).
 */
export function useWorkbenchPromptFieldHeight(fieldRef, text, { maxHeightPx = 200 } = {}) {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const el = fieldRef?.current;
    if (!el) return;
    const isTextarea = el.tagName === 'TEXTAREA';
    const isContentEditable = el.getAttribute('contenteditable') === 'true';
    if (!isTextarea && !isContentEditable) return;

    el.style.height = 'auto';
    const raw = el.scrollHeight;
    const h = Math.min(raw, maxHeightPx);
    el.style.height = `${h}px`;
    setHeight(raw);
  }, [text, maxHeightPx]);
  return height;
}
